import type { ButtonProps } from '@mui/material';
import { Box, Button, Chip, Typography, useTheme } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { isNotEmptyString } from '@weft/utils';
import { NavLink } from 'react-router-dom';

export type HomePageQuickLinkNavButtonProps = {
  label: string;
  chipLabel?: string;
  to: string;
} & ButtonProps;

export const HomePageQuickLinkNavButton: React.FC<HomePageQuickLinkNavButtonProps> = ({ label, chipLabel, to, ...buttonProps }) => {
  const vyTheme = useTheme();
  
  return (
    <Button
      color="secondary"
      component={NavLink}
      to={to}
      sx={theme => ({
        width: '100%',
        padding: 1,
        display: 'flex',
        gap: 2,
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: '8px',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        color: theme.palette.text.primary,
      })}
      {...buttonProps}
    >
      <Box sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
        height: '48px',
        width: '48px',
        borderRadius: '9.6px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      })}
      >
        <VyIcon
          color={buttonProps.disabled ?
            vyTheme.palette.text.disabled :
            vyTheme.palette.secondary.main
          }
          icon='InvoiceList3'
        />
      </Box>
      <Box>
        <Typography variant='body2'>{label}</Typography>
        {isNotEmptyString(chipLabel) && (
          <Chip 
            size='small'
            sx={{
              height: '16px',
            }}
            disabled={buttonProps.disabled}
            label={
              <Typography fontSize="11px">{chipLabel}</Typography>
            }
          />
        )}
      </Box>
    </Button>
  );
};